import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="total-cost"
export default class extends Controller {
  static targets = ["input", "output"];

  connect() {
    this.calculate();
  }

  calculate() {
    let total = 0;
    for (const input of this.inputTargets) {
      const rawValue = input.value.replace(/[^0-9.-]+/g, "");
      total += parseFloat(rawValue) || 0;
    }

    this.outputTarget.textContent = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(total);
  }
}
